var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDlNtBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 116,
    viewBox: "0 0 335 116",
    width: 335,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m335 0v116h-335v-116z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m159 0c6.075132 0 11 4.92486775 11 11v92c0 6.075132-4.924868 11-11 11h-148c-6.07513225 0-11-4.924868-11-11v-92c0-6.07513225 4.92486775-11 11-11z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.288 0v8.46h-1.464v-6.96l-1.512.42-.312-1.2 2.268-.72z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.216 0c1.644 0 2.772 1.008 2.772 2.508v.024c0 1.32-.696 2.04-2.184 3.252l-1.728 1.44h3.996v1.296h-6.072v-1.164l2.892-2.46c1.152-.984 1.572-1.512 1.572-2.268 0-.828-.588-1.308-1.356-1.308s-1.296.42-1.932 1.26l-1.056-.828c.804-1.116 1.596-1.752 3.096-1.752z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.024 0v1.104l-2.34 2.4c1.272.156 2.472.804 2.472 2.352v.024c0 1.548-1.188 2.664-2.94 2.664-1.464 0-2.508-.612-3.216-1.476l1.032-.96c.6.708 1.272 1.104 2.208 1.104.828 0 1.452-.504 1.452-1.272v-.024c0-.828-.756-1.296-1.932-1.296h-.684l-.24-.924 2.268-2.412h-3.636v-1.284z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.928 0v5.364h1.2v1.212h-1.2v1.884h-1.416v-1.884h-4.236l-.276-1.056 4.668-5.52zm-1.416 2.04-2.76 3.324h2.76z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.832 0v1.308h-3.756l-.132 1.968c.396-.144.768-.24 1.332-.24 1.632 0 2.928.864 2.928 2.64v.024c0 1.716-1.26 2.844-3.12 2.844-1.284 0-2.292-.516-3.084-1.284l.912-1.068c.672.624 1.38 1.008 2.16 1.008 1.008 0 1.668-.576 1.668-1.452v-.024c0-.852-.72-1.392-1.74-1.392-.6 0-1.116.168-1.548.372l-.888-.588.24-4.116z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.6 0c1.092 0 1.836.348 2.568.936l-.792 1.14c-.588-.456-1.08-.732-1.824-.732-1.464 0-1.992 1.524-2.016 2.676.492-.516 1.116-.852 2.016-.852 1.62 0 2.928.96 2.928 2.64v.024c0 1.668-1.356 2.856-3.12 2.856-1.032 0-1.776-.324-2.34-.888-.636-.636-1.02-1.512-1.02-3.204v-.024c0-2.568 1.224-4.572 3.6-4.572zm-.312 4.404c-1.044 0-1.704.672-1.704 1.476v.024c0 .852.696 1.5 1.74 1.5s1.68-.648 1.68-1.512v-.024c0-.84-.672-1.464-1.716-1.464z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.904 0v1.116l-3.78 7.284h-1.668l3.768-7.104h-4.224v-1.296z"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.204 0c1.68 0 2.916.972 2.916 2.268v.024c0 .936-.516 1.5-1.224 1.872.924.42 1.512 1.02 1.512 2.016v.024c0 1.5-1.368 2.436-3.204 2.436s-3.204-.96-3.204-2.412v-.024c0-1.008.564-1.644 1.512-2.04-.708-.372-1.224-.936-1.224-1.872v-.024c0-1.284 1.236-2.268 2.916-2.268zm0 4.848c-.996 0-1.752.504-1.752 1.272v.024c0 .684.648 1.26 1.752 1.26s1.764-.564 1.764-1.26v-.024c0-.768-.768-1.272-1.764-1.272zm0-3.612c-.9 0-1.5.528-1.5 1.164v.024c0 .732.636 1.248 1.5 1.248s1.5-.516 1.5-1.236v-.024c0-.648-.6-1.176-1.5-1.176z"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.054 0c1.806 0 2.898.63 3.836 1.526l-1.106 1.274c-.784-.728-1.624-1.218-2.744-1.218-1.862 0-3.234 1.54-3.234 3.458v.028c0 1.918 1.358 3.472 3.234 3.472 1.204 0 1.974-.476 2.814-1.26l1.106 1.12c-1.022 1.064-2.142 1.736-3.976 1.736-2.856 0-4.984-2.226-4.984-5.04v-.028c0-2.786 2.086-5.068 5.054-5.068z"
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.43 0c1.106 0 1.932.294 2.45.826.546.532.798 1.316.798 2.282v4.382h-1.652v-.924c-.504.602-1.274 1.078-2.408 1.078-1.386 0-2.618-.798-2.618-2.282v-.028c0-1.596 1.246-2.38 3.052-2.38.826 0 1.414.126 1.988.308v-.182c0-1.05-.644-1.61-1.834-1.61-.826 0-1.442.182-2.114.462l-.448-1.33c.812-.364 1.61-.602 2.786-.602zm-.042 4.032c-1.092 0-1.736.462-1.736 1.232v.028c0 .714.63 1.12 1.442 1.12 1.12 0 1.974-.644 1.974-1.582v-.504c-.434-.168-1.008-.294-1.68-.294z"
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.11013588.00075424.20186412.00216154v1.792h-.098c-1.484 0-2.52.966-2.52 2.926v2.814h-1.694v-7.392h1.694v1.666c.462-1.106 1.316-1.862 2.618-1.806z"
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.644 0v10.22h-1.694v-1.232c-.546.77-1.316 1.386-2.52 1.386-1.736 0-3.43-1.386-3.43-3.836v-.028c0-2.45 1.666-3.836 3.43-3.836 1.218 0 1.988.602 2.52 1.302v-3.976zm-3.808 4.144c-1.162 0-2.128.896-2.128 2.366v.028c0 1.428.98 2.366 2.128 2.366 1.134 0 2.142-.952 2.142-2.366v-.028c0-1.428-1.008-2.366-2.142-2.366z"
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.004 0c1.666 0 2.632 1.12 2.632 2.828v4.718h-1.694v-4.2c0-1.148-.574-1.806-1.582-1.806-.98 0-1.666.686-1.666 1.834v4.172h-1.694v-7.392h1.694v1.134c.476-.686 1.162-1.288 2.31-1.288z"
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.694 0v4.2c0 1.148.574 1.792 1.582 1.792.98 0 1.666-.672 1.666-1.82v-4.172h1.708v7.392h-1.708v-1.148c-.476.7-1.162 1.302-2.31 1.302-1.666 0-2.632-1.12-2.632-2.842v-4.704z"
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.652 0c1.61 0 2.59 1.022 2.59 2.828v4.718h-1.694v-4.2c0-1.176-.546-1.806-1.498-1.806-.924 0-1.582.644-1.582 1.834v4.172h-1.694v-4.214c0-1.148-.56-1.792-1.498-1.792s-1.582.7-1.582 1.834v4.172h-1.694v-7.392h1.694v1.12c.476-.658 1.12-1.274 2.254-1.274 1.064 0 1.82.518 2.212 1.302.588-.784 1.372-1.302 2.492-1.302z"
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.694 0v4.06c.546-.77 1.316-1.386 2.52-1.386 1.736 0 3.43 1.372 3.43 3.836v.028c0 2.45-1.68 3.836-3.43 3.836-1.232 0-2.002-.616-2.52-1.302v1.148h-1.694v-10.22zm2.114 4.144c-1.148 0-2.156.952-2.156 2.366v.028c0 1.414 1.008 2.366 2.156 2.366 1.162 0 2.114-.91 2.114-2.366v-.028c0-1.428-.966-2.366-2.114-2.366z"
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.612 0c2.352 0 3.542 1.848 3.542 3.976 0 .154-.014.308-.028.476h-5.432c.182 1.204 1.036 1.876 2.128 1.876.826 0 1.414-.308 2.002-.882l.994.882c-.7.84-1.666 1.386-3.024 1.386-2.142 0-3.794-1.554-3.794-3.836v-.028c0-2.114 1.498-3.85 3.612-3.85zm-.014 1.386c-1.036 0-1.764.798-1.918 1.946h3.794c-.112-1.092-.756-1.946-1.876-1.946z"
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.11013588.00075424.20186412.00216154v1.792h-.098c-1.484 0-2.52.966-2.52 2.926v2.814h-1.694v-7.392h1.694v1.666c.462-1.106 1.316-1.862 2.618-1.806z"
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.31222707 0 8.31222703 16.6244541h-16.6244541z"
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m100 0c6.075132 0 11 4.92486775 11 11v51c0 6.0751322-4.924868 11-11 11h-89c-6.07513225 0-11-4.9248678-11-11v-51c0-6.07513225 4.92486775-11 11-11z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82 1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h170v114h-170z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m11 0h148c6.075132 0 11 4.92486775 11 11v92c0 6.075132-4.924868 11-11 11h-148c-6.07513225 0-11-4.924868-11-11v-92c0-6.07513225 4.92486775-11 11-11z",
    fill: "none",
    stroke: "#969696",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(74.312 96.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.288v8.46h-3.288z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "translate(79.34 96.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.072v8.52h-6.072z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(86.624 96.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.156v8.544h-6.156z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "translate(93.956 96.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.128v8.46h-7.128z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "translate(102.272 96.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.204v8.544h-6.204z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "translate(109.868 96.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.48v8.688h-6.48z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "translate(117.656 96.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.904v8.4h-5.904z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "translate(124.604 96.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.408v8.64h-6.408z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "translate(185.454821 83.032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h8.96v10.136h-8.96z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "translate(195.534821 85.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.678v7.644h-6.678z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "translate(204.242821 85.465084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h4.312v7.53491578h-4.312z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    transform: "translate(209.436821 82.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.644v10.374h-7.644z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "translate(185.692821 99.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.636v7.546h-6.636z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    transform: "translate(194.288821 99.608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.65v7.546h-6.65z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)",
    transform: "translate(203.052821 99.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h11.242v7.546h-11.242z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)",
    transform: "translate(216.352821 96.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.644v10.374h-7.644z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)",
    transform: "translate(225.340821 99.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h7.154v7.714h-7.154z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)",
    transform: "translate(234.202821 99.465084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h4.312v7.53491578h-4.312z",
    fill: "#242934"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)",
    transform: "matrix(0 -1 1 0 160 107.624454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16.6244541v16.6244541h-16.6244541z",
    fill: "#b81236"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 12)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h111v73h-111z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m11 0h89c6.075132 0 11 4.92486775 11 11v51c0 6.0751322-4.924868 11-11 11h-89c-6.07513225 0-11-4.9248678-11-11v-51c0-6.07513225 4.92486775-11 11-11z",
    fill: "none",
    stroke: "#969696",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#969696",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.62066263.60833333h109.23662237",
    transform: "translate(11 29.033333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.62066263.60833333h109.23662237",
    transform: "translate(11 47.283333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.62066263.60833333h109.23662237",
    transform: "translate(11 65.533333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.62066263 72.3916667v-71.78333337",
    transform: "translate(37.06783 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.62066263 72.3916667v-71.78333337",
    transform: "translate(65.618311 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.62066263 72.3916667v-71.78333337",
    transform: "translate(94.168792 12)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlNtBack);
export default __webpack_public_path__ + "static/media/dl_nt_back.05029a85312df59328f366c13f6fdfc5.svg";
export { ForwardRef as ReactComponent };